<template>
    <tr>
        <td colspan="4">
            <div class="row">
                <div class="col-md-12">
                    <div class="spinner"></div>
                </div>
            </div>
            <div class="row">
                <div class="col-md-12">
                    <div class="accordion">
                        <!-- <div class="accordion-item">
                            <div class="accordian-header"></div>
                            <div class="accordian-content"></div>
                        </div> -->
                      <div
                        class="accordion-item"
                        v-for="(item, index) in accomodationRoomSuppliments"
                        :key="index"
                      >
                        <div class="row accordian-header">
                            <div class="col-md-3">{{ item.name }}</div>
                            <div class="col-md-3">{{ item.board_basis }}</div>
                            <div class="col-md-3">{{ item.occupancy }}</div>
                            <div class="col-md-2">
                                <input
                                    title="Supplement"
                                    id="room_supplement"
                                    type="number"
                                    step="0.01"
                                    ref="supplement"
                                    class="room-table-price-input"
                                    v-model="item.supplement"
                                    v-on:change="updateRoom(item.id,item)"
                                />
                            </div>
                            <div class="col-md-1" @click="toggle(index)">
                                <svg
                                    class="caret"
                                    :class="{ rotated: openIndex === index }"
                                    width="16"
                                    height="16"
                                    viewBox="0 0 24 24"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg"
                                    >
                                    <path d="M6 9L12 15L18 9" stroke="#333" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                                    </svg>
                            </div>
                        </div>
                        <div class="content" :class="{ open: openIndex === index }">
                            <div class="row">
                                <div class="col-md-12" style="display: flex;justify-content: end;">
                                    <button class="button" @click="addNewSupplimentToRoom(index)"><span>Add +</span></button>
                                </div>
                            </div>
                            <div class="row mt-3">
                                <div class="col-md-12">
                                    <table class="table">
                                        <thead>
                                            <tr>
                                                <th>Supliment Start Date</th>
                                                <th>Supliment End Date</th>
                                                <th>Booking Start Date</th>
                                                <th>Booking End Date</th>
                                                <th>Suppliment Price</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr v-for="(suppliment, suppliment_index) in item.accomodationSuppliments" :key="suppliment_index">
                                                <td>
                                                    <div class="form-group">
                                                    <input 
                                                        type="date"
                                                        class="form-control" 
                                                        name="" id="" 
                                                        v-model="suppliment.valid_from"
                                                        placeholder="Start date">
                                                    </div>
                                                </td>
                                                <td>
                                                    <div class="form-group">
                                                    <input 
                                                        type="date"
                                                        class="form-control" 
                                                        name="" id="" 
                                                        v-model="suppliment.valid_until"
                                                        placeholder="End date">
                                                    </div>
                                                </td>
                                                <td>
                                                    <div class="form-group">
                                                    <input 
                                                        type="date"
                                                        class="form-control" 
                                                        name="" id="" 
                                                        v-model="suppliment.booking_window_start"
                                                        placeholder="Start date">
                                                    </div>
                                                </td>
                                                <td>
                                                    <div class="form-group">
                                                    <input 
                                                        type="date"
                                                        class="form-control" 
                                                        name="" id="" 
                                                        v-model="suppliment.booking_window_end"
                                                        placeholder="End date">
                                                    </div>
                                                </td>
                                                <td>
                                                    <input
                                                        title="Supplement"
                                                        type="number"
                                                        step="0.01"
                                                        class="room-table-price-input"
                                                        v-model="suppliment.supplement"
                                                    />
                                                    &nbsp;
                                                    <template v-if="suppliment_index > 0">
                                                        <a class="icon icon--delete" @click="removeSupplimentFromRoom(index,suppliment_index)">Delete</a>
                                                    </template>
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                            <div class="row mb-3"  v-if="updateErrors.length > 0">
                                <div class="col-md-12">
                                    <div class="text-danger">
                                        <ul>
                                            <li v-for="(error, error_index) in updateErrors" :key="error_index">{{ error }}</li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-md-12">
                                    <button class="button" @click="updateRoomSuppliment(index)"><span>Update</span></button>
                                </div>
                            </div>
                        </div>
                      </div>
                    </div>
                </div>
            </div>
        </td>
    </tr>
  </template>
  
  <script>
  export default {
    name: "TourAccomodationRooms",
    props: {
        tourAccomodationRooms: {
            type: Array,
            required: true,
        },
    },
    created() {
        let __this = this
        this.accomodationRoomSuppliments = this.tourAccomodationRooms.map((item) => {
            return {
                ...item,
                accomodationSuppliments: (item.suppliments.length > 0) ? item.suppliments : [__this.getDefaultSuppliment(item.tour_accommodation_id, item.accommodation_room_id, item.id)]
            };
        });
    },
    data() {
        return {
            accomodationRoomSuppliments: [],
            openIndex: null,
            updateErrors: [],
        };
    },
    methods: {
        validateSuppliment(index) {
            return new Promise((resolve, reject) => {
                const validatedRoomSuppliment = this.accomodationRoomSuppliments[index].accomodationSuppliments;
                const errors = [];

                // Date-only comparison (avoids timezone issues)
                const dateLte = (d1, d2) => new Date(d1).setHours(0, 0, 0, 0) <= new Date(d2).setHours(0, 0, 0, 0);
                const rangesOverlap = (start1, end1, start2, end2) =>
                    dateLte(start1, end2) && dateLte(start2, end1);

                validatedRoomSuppliment.forEach((row, i) => {
                    const rowLabel = `Row ${i + 1}`;

                    // Required fields
                    if (!row.valid_from || !row.valid_until ||
                        !row.booking_window_start || !row.booking_window_end ||
                        row.supplement === '' || row.supplement === null || row.supplement === undefined) {
                        errors.push(`${rowLabel}: All fields are required.`);
                    }

                    // Supplement date range
                    if (row.valid_from && row.valid_until && !dateLte(row.valid_from, row.valid_until)) {
                        errors.push(`${rowLabel}: Supplement start date must be before or on end date.`);
                    }

                    // Booking date range
                    if (row.booking_window_start && row.booking_window_end &&
                        !dateLte(row.booking_window_start, row.booking_window_end)) {
                        errors.push(`${rowLabel}: Booking start date must be before or on end date.`);
                    }

                    if (row.supplement !== '' && row.supplement != null &&
                        (isNaN(Number(row.supplement)) || Number(row.supplement) < 0)) {
                        errors.push(`${rowLabel}: Supplement price must be a valid price.`);
                    }
                });
    
                // Cross-record: no overlap in supplement dates or effective period (booking dates may be the same)
                for (let i = 0; i < validatedRoomSuppliment.length; i++) {
                    const a = validatedRoomSuppliment[i];
                    for (let j = i + 1; j < validatedRoomSuppliment.length; j++) {
                        const b = validatedRoomSuppliment[j];

                        // 1) Supplement date ranges must not overlap
                        if (a.valid_from && a.valid_until && b.valid_from && b.valid_until &&
                            rangesOverlap(a.valid_from, a.valid_until, b.valid_from, b.valid_until)) {
                            errors.push(`Supplement date range of Row ${i + 1} overlaps with Row ${j + 1}`);
                        }

                        // 2) Effective period (supplement ∩ booking) must not overlap between rows
                        const effectiveStartA = [a.valid_from, a.booking_window_start].filter(Boolean).sort().pop();
                        const effectiveEndA = [a.valid_until, a.booking_window_end].filter(Boolean).sort().shift();
                        const effectiveStartB = [b.valid_from, b.booking_window_start].filter(Boolean).sort().pop();
                        const effectiveEndB = [b.valid_until, b.booking_window_end].filter(Boolean).sort().shift();
                        const hasValidA = effectiveStartA && effectiveEndA && dateLte(effectiveStartA, effectiveEndA);
                        const hasValidB = effectiveStartB && effectiveEndB && dateLte(effectiveStartB, effectiveEndB);
                        if (hasValidA && hasValidB && rangesOverlap(effectiveStartA, effectiveEndA, effectiveStartB, effectiveEndB)) {
                            errors.push(`Row ${i + 1} and Row ${j + 1} have overlapping effective periods (supplement and booking dates).`);
                        }
                    }
                }

                if (errors.length === 0) {
                    resolve(errors);
                } else {
                    reject(errors);
                }
            });
        },
        getDefaultSuppliment(tour_accomodation_id, accommodation_room_id, tour_room_id) {
            return {
                tour_accomodation_id,
                accommodation_room_id,
                tour_room_id,
                valid_from:null,
                valid_until:null,
                booking_window_start:null,
                booking_window_end:null,
                supplement:null
            };
        },
        toggle(index) {
            this.updateErrors = []
            this.openIndex = this.openIndex === index ? null : index;
        },
        updateRoom(room_id, item) {
            this.spinner = true
            fetch(this.$api + 'tours/rooms/' + room_id, {
            method: 'POST',
            body: JSON.stringify(item),
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json',
                'Authorization': localStorage.getItem('token')
            }
            })
            .then(res => res.json())
            .then(response => {
                this.errors = response.errors
                if(response.success) {
                    this.$notify({
                        type: 'success',
                        title: response.message
                    })
                } else {
                    this.$notify({
                        type: 'error',
                        title: response.message
                    });
                }
            })
            this.spinner = false
        },
        addNewSupplimentToRoom(index) {
            this.accomodationRoomSuppliments[index].accomodationSuppliments.push(this.getDefaultSuppliment(this.accomodationRoomSuppliments[index].tour_accommodation_id, this.accomodationRoomSuppliments[index].accommodation_room_id, this.accomodationRoomSuppliments[index].id))
        },
        removeSupplimentFromRoom(index,suppliment_index) {
            this.accomodationRoomSuppliments[index].accomodationSuppliments.splice(suppliment_index, 1)
        },
        updateRoomSuppliment(index) {
            this.updateErrors = []
            this.updateRoomSupplimentToServer(index)
            // this.validateSuppliment(index)
            //     .then((response) => {
            //     }).catch((error) => {
            //         this.updateErrors = error
            //     });
        },
        updateRoomSupplimentToServer(index) {
            this.spinner = true
            console.log(this.accomodationRoomSuppliments[index].accomodationSuppliments);
            
            fetch(this.$api + 'tours/accommodation/rooms/' + this.accomodationRoomSuppliments[index].id+'/update-suppliment', {
                method: 'POST',
                body: JSON.stringify({
                    accomodation_supplement: this.accomodationRoomSuppliments[index].accomodationSuppliments,
                }),
                headers: {
                    'Content-Type': 'application/json',
                    'Accept': 'application/json',
                    'Authorization': localStorage.getItem('token')
                }
            })
            .then(res => res.json())
            .then(response => {
                this.errors = response.errors
                if(response.success) {
                    this.$notify({
                        type: 'success',
                        title: response.message
                    })
                } else {
                    this.$notify({
                        type: 'error',
                        title: response.message
                    });
                }
            })
            this.spinner = false
        }
        
    },
  };
  </script>
  
  <style scoped>
    .accordion {
        /* max-width: 600px; */
        /* margin: 40px auto; */
        background: #fff;
        border-radius: 8px;
        overflow: hidden;
        box-shadow: 0 4px 10px rgba(0,0,0,0.1);
    }
    
    .accordion-item {
        border-bottom: 1px solid #ddd;
    }
    
    .accordion-item .accordian-header {
        /* display: block; */
        padding: 15px 20px; 
        font-weight: bold;
        cursor: pointer;
        background: #eee;
        transition: background 0.3s ease;
    }
    
    .accordion-item label:hover {
        background: #ddd;
    }
    
    .content {
        max-height: 0;
        overflow: hidden;
        padding: 0 20px;
        background: #fafafa;
        transition: max-height 0.4s ease, padding 0.4s ease;
    }
    
    .content.open {
        min-height: 200px;
        max-height: 500px;
        padding: 15px 20px;
        /* overflow-y: scroll; */
    }

    .caret {
        transition: transform 0.3s ease;
    }

    .caret.rotated {
        transform: rotate(180deg);
    }
</style>
  